import { AlertCircle } from "lucide-react";
import type { ReactNode } from "react";

export function PageHeader({ eyebrow, title, description, action }: { eyebrow: string; title: string; description: string; action?: ReactNode }) {
  return <header className="page-header"><div><span className="eyebrow">{eyebrow}</span><h1>{title}</h1><p>{description}</p></div>{action && <div className="page-action">{action}</div>}</header>;
}

export function LoadingState() {
  return <div className="skeleton-panel" aria-label="正在读取数据"><span className="skeleton-title" /><span className="skeleton-line wide" /><span className="skeleton-line" /><div className="skeleton-grid"><i /><i /><i /></div></div>;
}

export function ErrorState({ message, retry }: { message: string; retry?: () => void }) {
  return <div className="state-panel error"><AlertCircle /><strong>暂时无法读取数据</strong><p>{message}</p>{retry && <button className="button secondary" onClick={retry}>重新加载</button>}</div>;
}

export function EmptyState({ icon, title, description, action }: { icon: ReactNode; title: string; description: string; action?: ReactNode }) {
  return <div className="empty-state"><div className="empty-illustration">{icon}</div><h3>{title}</h3><p>{description}</p>{action}</div>;
}
